import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Lead API service
export const submitLead = async (firstName, email) => {
  try {
    const response = await axios.post(`${API}/leads`, {
      firstName,
      email
    });
    return response.data;
  } catch (error) {
    console.error('Lead submission error:', error);
    throw error;
  }
};

export const getLeads = async () => {
  try {
    const response = await axios.get(`${API}/leads`);
    return response.data;
  } catch (error) {
    console.error('Get leads error:', error);
    throw error;
  }
};
